import React from 'react';
import Link from '../../../components/LocalizedLink';

const tegevused = {
  "tegevused.yld.pealkiri": "Aktiivsed tegevused",
  "tegevused.yld.blokk1": () => (
    <>
      <h2 className="title is-2">Aktiivsed tegevused Varbla puhkekülas</h2>
      <p>
        Passiivne puhkus on küll hea ja vajalik, kuid ka sellest tüdinetakse.
        Sel puhul on meie juures võimalik tegeleda erinevate aktiviteetidega.
      </p>
    </>
  ),
  "tegevused.windsurf.pealkiri": "Windsurf",
  "tegevused.windsurf.kaart.kirjeldus": () => (
    <div>
      <p>Tule ja avasta enese jaoks windsurf!</p>
      <p>
        Kõik uued surfihuvilised saavad purjelauaõppega tutvust teha kenas
        liivarannas, kus on olemas parajalt nii tuult kui ka päikest ning
        ideaalsed esmased õppimisvõimalused.
      </p>
    </div>
  ),
  "tegevused.windsurf.blokk1": () => (
    <>
      <h2 className="title is-2">Windsurf</h2>
      <p>Tule ja avasta enese jaoks windsurf!</p>
      <p>See on huvitav hobi, mis tasub kindlasti järeleproovimist.</p>
      <p>
        Suurepärane lisategevus suvepäevadele, kokkutulekutele, seminaride ja
        koolituste põnevamaks muutmiseks, kui ka suurematele seltskondadele
        aktiivse puhkuse veetmiseks.
      </p>
      <p>
        Kõik uued surfihuvilised saavad purjelauaõppega tutvust teha kenas
        liivarannas, kus on olemas parajalt nii tuult kui ka päikest ning
        ideaalsed esmased õppimisvõimalused.
      </p>
      <p>Kohapeal jagab esmaseid näpunäiteid kogenud surfikoolitaja.</p>
      <p>
        Täpsem info ja tellimine{" "}
        <a href="http://verpelsurf.wix.com/surfikoolitus">
          http://verpelsurf.wix.com/surfikoolitus
        </a>
      </p>
    </>
  ),
  "tegevused.sup.pealkiri": "Sup",
  "tegevused.sup.kaart.kirjeldus": () => (
    <div>
      <p>
        Kui meri ikka kutsub, aga mitte nii ekstreemsel näol kui selleks on
        Windsurf, siis SupSurf on ideaalne lahendus sulle. Tule ja aeruta vastu
        imelisele päikeseloojangule oma kallimaga, muuda oma hommikune trenn
        natukene ekstreemseks või võta oma sõbrad kaasa ja minge ühele vingele
        Sup-laua matkale Varbla laidude vahel, kõik see on meie juures võimalik.
      </p>
    </div>
  ),
  "tegevused.sup.blokk1": () => (
    <div>
      <h2 className="title is-2">Sup</h2>
      <p>
        Kui meri ikka kutsub, aga mitte nii ekstreemsel näol kui selleks on
        Windsurf, siis SupSurf on ideaalne lahendus sulle.
      </p>
      <p>
        Tule ja aeruta vastu imelisele päikeseloojangule oma kallimaga, muuda
        oma hommikune trenn natukene ekstreemseks või võta oma sõbrad kaasa ja
        minge ühele vingele Sup-laua matkale Varbla laidude vahel, kõik see on
        meie juures võimalik.
      </p>
      <p>Hetkel on meil välja rentida 10 Sup-lauda.</p>
      <p>
        Sup-laua rent: <strong>...€/3tundi, ...€/päev</strong>
      </p>
    </div>
  ),
  "tegevused.pallimangud.pealkiri": "Pallimängud",
  "tegevused.pallimangud.kaart.kirjeldus": () => (
    <div>
      <p>
        Kellele meeldib rannavolley, kellele jalgpall, kellele lihtsalt palli
        korvi loopida, meil saab neid spordialasid harrastada.
      </p>
    </div>
  ),
  "tegevused.pallimangud.blokk1": () => (
    <div>
      <h2 className="title is-2">Pallimängud</h2>
      <p>
        Kellele meeldib rannavolley, kellele jalgpall, kellele lihtsalt palli
        korvi loopida, meil saab neid spordialasid harrastada.
      </p>
      <p>
        Vabaajategevuste platsil on suurepärane liivast võrkpalli plats ja
        sellest vaid 100m kaugusel on rannajalgpalli mängimis võimalus.
      </p>
      <p>
        Motelli hoovis saab kätt proovile panna nii korvpalliväljakul kui ka
        petank mängus.
      </p>
    </div>
  ),
  "tegevused.baar&piljard.pealkiri": "Baar & piljard",
  "tegevused.baar&piljard.kaart.kirjeldus": () => (
    <div>
      <p>
        Õhtu veetmiseks on avatud baar, kus saad kaasa haarata jahutava joogi,
        mida nautida koos päikeseloojanguga. Samuti on võimalus esitada
        väljakutse oma sõpradele nii piljardis kui ka lauajalgpallis.
      </p>
    </div>
  ),
  "tegevused.baar&piljard.blokk1": () => (
    <div>
      <h2 className="title is-2">Baar & piljard</h2>
      <p>
        Õhtu veetmiseks on avatud baar, kus saad kaasa haarata jahutava joogi,
        mida nautida koos päikeseloojanguga.
      </p>
      <p>
        Samuti on võimalus esitada väljakutse oma sõpradele nii piljardis kui ka
        lauajalgpallis.
      </p>
    </div>
  ),
  "tegevused.discgolf.pealkiri": "Discgolf",
  "tegevused.discgolf.kaart.kirjeldus": () => (
    <div>
      <p>
        Discgolfi populaarsus on Eestis viimaste aastatega meeletult kasvanud,
        mille tõttu ei saanud meiegi sellest kõrvale vaadata.
      </p>
    </div>
  ),
  "tegevused.discgolf.blokk1": () => (
    <div>
      <h2 className="title is-2">Discgolf</h2>
      <p>
        Discgolfi populaarsus on Eestis viimaste aastatega meeletult kasvanud,
        mille tõttu ei saanud meiegi sellest kõrvale vaadata.
      </p>
      <p>
        Rõõm on teatada, et aasta 2020 suvest on Varbla Puhkekülal oma Discgolf
        rada, mis koosneb 10st korvist, mis liigub mööda Varbla randa kuni
        tiheda kadastikuni välja.
      </p>
      <p>
        Tule veeda mõnus ja sportlik päev loopides kettaid, nautides värsket
        õhku ja imelist loodust.
      </p>
    </div>
  ),
  "tegevused.saunad.pealkiri": "Saunad",
  "tegevused.saunad.kaart.kirjeldus": () => (
    <div>
      <p>
        Saunamaja– asub kohe Peamaja (Ranna Motelli) kõrval. Hubaseks istumiseks
        on kaminaruum, mille pehmetel nahast diivanitel ja tugitoolidel saab
        nautida mõnusat olemist ja praksuvat kaminatuld.
      </p>
      <p>
        Juuli & Aadu Saunamaja– Võimalus rentida terveks ööpäevaks saunamaja,
        mille esimesel korrusel on saun, wc, dušš ja puhke- ning kööginurk,
        teisel korrusel 10 magamisaset.
      </p>
    </div>
  ),
  "tegevused.saunad.blokk1": () => (
    <>
      <h2 className="title is-2">Saunad</h2>
      <p>
        <strong>Saunamaja</strong>– asub kohe Peamaja (Ranna Motelli) kõrval.
      </p>
      <p>
        Hubaseks istumiseks on kaminaruum, mille pehmetel nahast diivanitel ja
        tugitoolidel saab nautida mõnusat olemist ja praksuvat kaminatuld.
      </p>
      <p>Sauna keris on puuküttega.</p>
      <p>Koos „Leiliga” mahub saunalavale 5 inimest. </p>
      <p>
        Sauna kütmine sobivasse temperatuuri võtab meil aega 2 tundi. 1h= 25€ +
        2€ iga saunaline
      </p>
      <p>Väsinud saunalistel on võimalus ööbida Saunamaja teisele korrusel.</p>
      <p>
        Saunamaja ööbimisvõimalustest vaata lähemalt{" "}
        <Link to="/majutus/saunamajad">siit</Link>
      </p>
      <br />
      <p>
        <strong>Juuli & Aadu Saunamaja</strong>– Võimalus rentida terveks
        ööpäevaks saunamaja, mille esimesel korrusel on saun, wc, dušš ja puhke-
        ning kööginurk, teisel korrusel 10 magamisaset.
      </p>
      <p>
        Rentimisest ja ööbimisvõimalustest vaata lähemalt{" "}
        <Link to="/majutus/saunamajad">siit</Link>
      </p>
    </>
  ),
  "tegevused.paadirent.pealkiri": "Paadirent & kalastus",
  "tegevused.paadirent.kaart.kirjeldus": () => (
    <div>
      <p>
        Sisusta oma puhkusepäev toreda paadisõiduga Liivi lahel! Paadisõidu
        saate ühendada kalapüügi ja piknikuga merel või laiul.
      </p>
    </div>
  ),
  "tegevused.paadirent.blokk1": () => (
    <>
      <h2 className="title is-2">Paadirent & kalastus</h2>
      <p>
        Sisusta oma puhkusepäev toreda paadisõiduga Liivi lahel! Paadisõidu
        saate ühendada kalapüügi ja piknikuga merel või laiul.
      </p>
      <p>Siin pole pelgalt tühi meri vaid mitmekülgne laiduderikas maastik.</p>
      <p>
        Kevadel on eriti põnev linnuhuvilistel, kui algab lindude saabumine ja
        pesitsusaeg.
      </p>
      <p>Laidudel kohtab II ja III kaitsekategooria linnuliike.</p>
      <p>
        Romantikud saavad õhtuhakul osaks maalilisele päikeseloojangule,
        kalastajad aga kalaõnne korral õhtuks grillida hõrku värsket kala.
      </p>
      <p>Meil on 2 aerupaati.</p>
      <p>
        Paadi rent 1h = <strong>7€</strong>
      </p>
      <p>
        <strong>
          NB! Kuna tegemist on kaitsealaga on laidudel keelatud viibida 15.
          aprillist kuni 30. juunini, kalastamine samuti.
        </strong>
      </p>
    </>
  ),
  "tegevused.jalgrattarent.pealkiri": "Jalgrattarent",
  "tegevused.jalgrattarent.kaart.kirjeldus": () => (
    <div>
      <p>
        Väga sportlik viis uurida Varblas toimuvat on jalgratas rentida ja
        avastama minna.
      </p>
    </div>
  ),
  "tegevused.jalgrattarent.blokk1": () => (
    <div>
      <h2 className="title is-2">Jalgrattarent</h2>
      <p>
        Väga sportlik viis uurida Varblas toimuvat on jalgratas rentida ja
        avastama minna.
      </p>
      <p>
        Suurematel pidustustel on jalgratas suurepärane lahendus Motelli ja
        vabaajategevuste platsi vahel liiklemiseks.
      </p>
      <p>Võimalik laenutada kokku 8 jalgratast.</p>
      <p>Palume kindlasti ette helistada!</p>
    </div>
  ),
  "tegevused.jahindus.pealkiri": "Jahindus",
  "tegevused.jahindus.kaart.kirjeldus": () => (
    <div>
      <p>
        Korraldame jahisõpradele jahti Varbla, Saulepi ja Vatla jahipiirkonnas,
        ca 36 000 ha suurusel maa-alal.Meie metsades on arvukalt põtru,
        metssigu, metskitsi ja -sokke, ilveseid ja hunte. Nähtud on isegi
        karusid.
      </p>
    </div>
  ),
  "tegevused.jahindus.blokk1": () => (
    <>
      <h2 className="title is-2">Jahindus</h2>
      <p>Head jahisõbrad – olete oodatud Varbla Puhkekülla !</p>
      <p>Harrastused ja huvid on meil paljudel.</p>
      <p>
        Kuid ühed kummalisemad on jahimehed, sest jahihooaja saabudes ei suuda
        neid mingi väega sellest harrastusest eemal hoida – olgu siis ilm
        milline tahes, ikka “kisub metsa poole”.
      </p>
      <p>
        Tore, et on selliseid fanaatilisi inimesi, sest just sellised on meie
        juurde Varbla Puhkekülla oodatud.
      </p>
      <p>
        Korraldame jahisõpradele jahti Varbla, Saulepi ja Vatla jahipiirkonnas,
        ca 36 000 ha suurusel maa-alal.
      </p>
      <p>
        Meie metsades on arvukalt põtru, metssigu, metskitsi ja -sokke, ilveseid
        ja hunte.
      </p>
      <p>Nähtud on isegi karusid.</p>
      <br />
      <p>Korraldame koostöös kohalike jahisektsioonidega</p>
      <strong>SUURULUKIJAHTI:</strong>
      <ul>
        <li>põder 15.09. – 30.11.</li>
        <li>metskits 01.06. – 30.11.</li>
        <li>metssiga 01.06. – 28.02.</li>{" "}
        <li>ilves, hunt – jahilubade olemasolul</li>
      </ul>
      <strong>VÄIKEULUKIJAHTI:</strong>
      <ul>
        <li>kobras 01.08. – 15.04.</li>
      </ul>
      <strong>LINNUJAHTI:</strong>
      <ul>
        <li>part 20.08. – 30.11.</li>
        <li>hani 10.09. – 30.11.</li>
        <li>metskurvits e. nepp 01.10. – 15.11.</li>
      </ul>
      <p>
        Et jahile tulla, peab teil olemas olema järgmised kehtivad dokumendid: –
        kehtiv jahitunnistus – kehtiv relvaluba – välismaalastel suuruluki
        laskekatse tunnistus (suuruluki jahile tulles)
      </p>
    </>
  ),
  "tegevused.koostoopartnerid.pealkiri": "Seiklusmängud koostööpartneritelt",
  "tegevused.koostoopartnerid.kaart.kirjeldus": () => (
    <div>
      <p>
        Koostöös partneritega korraldame Varblas aastaringselt erinevaid
        meeskonnamänge.
      </p>
    </div>
  ),
  "tegevused.koostoopartnerid.blokk1": () => (
    <div>
      <h2 className="title is-2">Meeskonnamängud 360 kraadi</h2>
      <p>KÕIK MÄNGUD ON:</p>
      <ul>
        <li>meeskondlikud</li>
        <li>aktiivse osaga 2-3 tundi</li>
        <li>läbitavad tavariietuses</li>
        <li>saadaval aastaringselt iga ilmaga</li>
        <li>saadaval erinevates keeltes</li>
        <li>saadaval 2-3 päevase etteteatamistähtajaga</li>
      </ul>
      <p>MÄNGUDE LISAINFO:</p>
      <ul>
        <li>korraldaja poolt kogu vajalik varustus</li>
        <li>võitjatiimile auhind</li>
        <li>vihma korral kõigile vihmakeebid, pimedal ajal pealambid jmv</li>
        <li>Hinnad sisaldavad käibemaksu 20%</li>
        <li>
          Hind muutub vastavalt osalejate arvule, mida saab korrigeerida kuni 1
          päev enne üritust.
        </li>
      </ul>
    </div>
  ),
  "tegevused.koostoopartnerid.blokk2": () => (
    <div>
      <h2 className="title is-2">Seikluspartner</h2>
      <p>
        Seikluspartner pakub tegevusi suvepäevadeks, meeskonnakoolitusteks,
        matkadeks, kooliekskursioonideks. Sobiv ka väiksematele sõpruskondadele.
      </p>
    </div>
  ),
};

export default tegevused;
